import request from '../../utils/request'

/**
 * 获取动态菜单列表
 * @param {Object} params - 查询参数
 * @param {number} params.type - 菜单类型 1-web; 2-小程序
 * @param {string} params.userId - 用户ID（可选）
 * @param {string} params.id - 菜单ID（可选）
 * @param {string} params.name - 菜单名称（可选）
 * @param {string} params.code - 菜单code（可选）
 * @returns {Promise}
 */
export function queryWebMenu (params) {
  return request({
    url: '/gsd/webMenu/queryWebMenu',
    method: 'post',
    data: {
      userId: params.userId || '1',
      id: params.id || '',
      type: params.type || 1,
      name: params.name || '',
      code: params.code || ''
    }
  })
}

/**
 * 获取动态菜单树状图
 * @param {Object} params - 查询参数
 * @param {number} params.type - 菜单类型 1-web; 2-小程序
 * @param {string} params.userId - 用户ID（可选）
 * @param {string} params.id - 菜单ID（可选）
 * @param {string} params.name - 菜单名称（可选）
 * @param {string} params.code - 菜单code（可选）
 * @returns {Promise}
 */
export function queryWebMenuTree (params) {
  return request({
    url: '/gsd/webMenu/queryWebMenuTree',
    method: 'post',
    data: {
      userId: params.userId || '1',
      id: params.id || '',
      type: params.type || 1,
      name: params.name || '',
      code: params.code || ''
    }
  })
}

/**
 * 获取动态菜单内容详情
 * @param {Object} params - 查询参数
 * @param {string} params.webMenuId - 菜单ID
 * @param {string} params.userId - 用户ID（可选）
 * @returns {Promise}
 */
/**
 * 获取动态菜单内容详情
 * @param {Object} params - 查询参数
 * @param {string} params.webMenuId - 菜单ID
 * @param {string} params.userId - 用户ID（可选）
 * @param {string} params.id - 内容ID（可选）
 * @returns {Promise}
 */
export function getMenuHtmlDetail (params) {
  return request({
    url: '/gsd/webMenuHtml/getMenuHtmlDetail',
    method: 'post',
    data: {
      userId: params.userId || '1',
      id: params.id || '',
      webMenuId: params.webMenuId
    }
  })
}

/**
 * 新增编辑咨询信息
 * @param {Object} params - 咨询信息参数
 * @param {string} params.id - 咨询信息ID（编辑时必填，新增时可不填）
 * @param {string} params.name - 名称（必填）
 * @param {string} params.mobile - 手机号（必填）
 * @param {string} params.msgContent - 咨询内容（必填）
 * @param {number} params.status - 类型 1-待处理；2-已处理（必填）
 * @param {string} params.remark - 备注（可选）
 * @param {number} params.sort - 排序（可选）
 * @param {string} params.handleOpinion - 处理意见（可选）
 * @returns {Promise}
 */
export function editConsultationMessage (params) {
  return request({
    url: '/gsd/consultationMessage/editMessage',
    method: 'post',
    data: {
      id: params.id || '',
      name: params.name,
      mobile: params.mobile,
      msgContent: params.msgContent,
      status: params.status || 1, // 默认待处理
      remark: params.remark || '',
      sort: params.sort || 1,
      handleOpinion: params.handleOpinion || ''
    }
  })
}

/**
 * 查询动态HTML列表（公司动态/行业咨询）
 * @param {Object} params - 查询参数
 * @param {string} params.webCode - 菜单code（必填）
 * @param {string} params.type - 内容类型 1-源码；2-链接；88-行业咨询/公司动态
 * @param {number} params.pageNo - 页码，从1开始
 * @param {number} params.pageSize - 每页条数
 * @param {number} params.status - 类型 1-待生效;2-已生效；3-失效
 * @param {string} params.title - 标题（可选）
 * @param {string} params.id - 动态id（可选）
 * @returns {Promise}
 */
export function queryDynamicHtmlList (params) {
  return request({
    url: '/gsd/webDynamicHtml/queryDynamicHtmlList',
    method: 'post',
    data: {
      webCode: params.webCode,
      type: params.type || '88',
      pageNo: params.pageNo || 1,
      pageSize: params.pageSize || 10,
      status: params.status || 2,
      title: params.title || '',
      id: params.id || ''
    }
  })
}

/**
 * 查询动态HTML详情
 * @param {Object} params - 查询参数
 * @param {string} params.id - 动态id（必填）
 * @returns {Promise}
 */
export function queryDynamicHtmlDetail (params) {
  return request({
    url: '/gsd/webDynamicHtml/queryDynamicHtmlDetail',
    method: 'post',
    data: {
      id: params.id
    }
  })
}
